import React from 'react';
import { blueGrey, green } from '@mui/material/colors';
import { Box, Grid } from '@mui/material';
import ActivityIcon from '@mui/icons-material/Assignment';
import MediaIcon from '@mui/icons-material/OndemandVideo';
import StudentsIcon from '@mui/icons-material/SupervisedUserCircle';
import CoursesIcon from '@mui/icons-material/Class';
import AssignmentsIcon from '@mui/icons-material/Work';
import PracticeIcon from '@mui/icons-material/FitnessCenter';
import ReceiptIcon from '@mui/icons-material/Receipt';

import { priceFormatter } from '@ts-core/utils/priceFormatter';

import { AcademyActivityByMonth } from '@ts-core/modules/billing/types';

import Typography from '@ts-core/components/Typography';

export interface ActivityOverviewTilesProps {
  loading?: boolean;
  activityOverview?: AcademyActivityByMonth;
}

type TileId = 'coursesCount' | 'studentsCount' | 'mediaSessionsCount' | 'assignmentAnswersCount' | 'practiceSessionsCount' | 'activityAnswersCount';

const tiles: { id: TileId; label: string; icon: React.ReactElement }[] = [
  {
    id: 'coursesCount',
    label: 'Cursos',
    icon: <CoursesIcon />,
  },
  {
    id: 'studentsCount',
    label: 'Alumnos',
    icon: <StudentsIcon />,
  },
  {
    id: 'mediaSessionsCount',
    label: 'Videos',
    icon: <MediaIcon />,
  },
  {
    id: 'assignmentAnswersCount',
    label: 'Entregas',
    icon: <AssignmentsIcon />,
  },
  {
    id: 'practiceSessionsCount',
    label: 'Practicas',
    icon: <PracticeIcon />,
  },
  {
    id: 'activityAnswersCount',
    label: 'Tareas',
    icon: <ActivityIcon />,
  },
];

export function ActivityOverviewTiles(props: ActivityOverviewTilesProps) {
  const { loading, activityOverview } = props;

  return (
    <Box width="100%">
      <Grid container spacing={1}>
        {tiles.map((tile) => (
          <Grid key={tile.id} item xs={6} sm={4} md={3}>
            <Box bgcolor={blueGrey[100]} borderRadius={2} p={2}>
              <Typography loading={loading} fontSize={30} fontWeight={700} skeletonProps={{ width: 60 }}>
                {activityOverview?.[tile.id]}
              </Typography>
              <Box display="flex" mt={2} alignItems="center">
                {tile.icon}
                <Typography fontSize={16} fontWeight={700} ml={1}>
                  {tile.label}
                </Typography>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
      <Grid container spacing={1} mt={3} mb={2}>
        <Grid item xs={6} sm={4} md={3}>
          <Box bgcolor={green[100]} borderRadius={2} p={2}>
            <Typography loading={loading} fontSize={30} fontWeight={700} skeletonProps={{ width: 60 }}>
              {priceFormatter(activityOverview?.academy?.pricing?.currency, activityOverview?.totalCost)}
            </Typography>
            <Box display="flex" mt={2} alignItems="center">
              <ReceiptIcon />
              <Typography fontSize={16} fontWeight={700} ml={1}>
                Costo
              </Typography>
            </Box>
            <Typography fontSize={12} fontWeight={100} ml={1}>
              * Los precios incluyen IVA
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
